if (!customElements.get('shippingbar-container')) {
    class ShippingBarContainer extends HTMLElement {
        constructor() {
            super();
        }

        connectedCallback() {
            const goalValues = this.dataset.goalValues?.split(',').map(Number) || [];
            const cartValue = parseFloat(this.dataset.cartValue) || 0;

            let lastGoal = parseFloat(localStorage.getItem('lastTriggeredGoal')) || 0;

            // If cart value drops below the last goal, reset lastTriggeredGoal
            if (cartValue < lastGoal) {
                lastGoal = 0;
                localStorage.setItem('lastTriggeredGoal', lastGoal);
            }

            for (let goal of goalValues) {
                if (cartValue >= goal && lastGoal < goal) {
                    lastGoal = goal;
                    window.confettiShooter();
                    // Store last triggered goal in localStorage
                    localStorage.setItem('lastTriggeredGoal', lastGoal);
                }
            }
        }
    }

    customElements.define('shippingbar-container', ShippingBarContainer);
}
